import { useEffect } from "react";
import { useAccountQuery } from "features/auth/authApi";

export default function DataLayerUser() {
  const { data: account } = useAccountQuery();
  const email = account?.user?.login;
  const host = window.location.hostname;

  useEffect(() => {
    if (!host.includes("moonbitx") && !host.includes("kryptolad")) return;
    if (!email) return;
    if (sessionStorage.getItem("dfuPushed")) return;

    const w = window as any;
    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push({
      event: "userLoaded",
      userEmail: email,
    });
    console.log("DataLayerUser push:", email);

    sessionStorage.setItem("dfuPushed", "1");
  }, [host, email]);

  return null;
}
